import Vue from 'vue'

import Vuex from 'vuex'
import { stat } from 'fs'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  state: {
    userinfo: JSON.parse(localStorage.getItem('userinfo')) || {},
    token: localStorage.getItem('token') || '',
    ycorder: {
      // 约车订单
      start_city: '', // 宜宾市
      end_city: '',
      start_area: '', // 翠屏区
      end_area: '',
      start_location: '',
      end_location: '',
      start_address: '',
      end_address: '',
      persons: 1, // 乘车人数
      cartype: 0, // 车型,0为五座，1为7座
      depart_time: '', // 出发时间2019-05-24 11:55
      credit: 0, // 积分
      userid: 0,
      username: '',
      mobile: '', // 手机号
      money: '0', // 金额
      yctype: 0, // 0为拼车，1包车，2寄货
      oldmoney: 0, // 打折前金额
      distance: 0,
      duration: 0
    },
    isreverse: 0, // 路线的起点终点是否反转
    ratio: 0,
    lineinfo: {
      // 线路详情
    },
    gsphone: {
      complaint: '',
      contact: ''
    },
    having_order_show: true
  },
  getters: {
    // 首页进行中的订单是否显示
    getStateHavingOrderShow(state) {
      return state.having_order_show
    },
    // 获取state的方法
    getStatetoken(state) {
      return state.token
    },
    // 获取投诉电话和联系我们电话
    getGsphoneinfo(state) {
      return state.gsphone
    },
    getUserinfo(state) {
      return state.userinfo
    },
    // 获取线路详情信息
    getLineinfo(state) {
      return state.lineinfo
    },
    // 获取约车订单
    getStateycorder(state) {
      return state.ycorder
    },
    // 获取SelectAddress需要的信息
    getSelectAddressMsg(state) {
      let tem = {}
      tem.start_city = state.ycorder.start_city
      tem.end_city = state.ycorder.end_city
      tem.start_area = state.ycorder.start_area
      tem.end_area = state.ycorder.end_area
      tem.start_address = state.ycorder.start_address
      tem.end_address = state.ycorder.end_address
      tem.persons = state.ycorder.persons
      tem.cartype = state.ycorder.cartype
      tem.start_location = state.ycorder.start_location
      tem.end_location = state.ycorder.end_location
      return tem
    },
    // 获取Ordermsg需要的信息
    getOrderMsg(state) {
      let tem = {}
      tem.depart_time = state.ycorder.depart_time
      tem.credit = state.ycorder.credit
      tem.mobile = state.ycorder.mobile
      tem.money = state.ycorder.money
      tem.oldmoney = state.ycorder.oldmoney
      tem.distance = state.ycorder.distance
      tem.duration = state.ycorder.duration
      return tem
    },
    // 获取Ordermsg需要的信息
    getAddressMsg(state) {
      let tem = {}
      tem.start_city = state.ycorder.start_city
      tem.end_city = state.ycorder.end_city
      tem.start_area = state.ycorder.start_area
      tem.end_area = state.ycorder.end_area
      tem.start_location = state.ycorder.start_location
      tem.end_location = state.ycorder.end_location
      return tem
    },
    // getDepartTime
    getDepartTime(state) {
      return state.ycorder.depart_time
    }
  },
  mutations: {
    // 设置进行中的订单状态
    setStateHavingOrderShow(state, status) {
      state.having_order_show = status
    },
    // 改变state的方法
    setStateToken(state, token) {
      localStorage.setItem('token', token)
      state.token = token
    },
    setStateUserinfo(state, userinfo) {
      state.userinfo = userinfo
      localStorage.setItem('userinfo', JSON.stringify(userinfo))
    },
    // 改变约车订单信息
    setYcorder(state, order) {
      state.ycorder = order
    },
    // 设置约车订单那些提示信息Ordermsg组件
    setOrderMsg(state, msg) {
      state.ycorder.depart_time = msg.depart_time
      state.ycorder.credit = msg.credit
      state.ycorder.mobile = msg.mobile
      state.ycorder.money = msg.money
      state.ycorder.oldmoney = msg.oldmoney
    },
    // 设置SelectAddress需要的信息
    setSelectAddressMsg(state, msg) {
      state.ycorder.start_city = msg.start_city
      state.ycorder.end_city = msg.end_city
      state.ycorder.start_area = msg.start_area
      state.ycorder.end_area = msg.end_area
      state.ycorder.start_address = msg.start_address
      state.ycorder.end_address = msg.end_address
      state.ycorder.persons = msg.persons
      state.ycorder.cartype = msg.cartype
      state.ycorder.start_location = msg.start_location
      state.ycorder.end_location = msg.end_location
    },
    // 根据选择设置价格和积分
    setMoneyCredit(state, msg) {
      state.ycorder.money = msg.money
      state.ycorder.credit = msg.credit
      state.ycorder.oldmoney = msg.oldmoney
      state.ycorder.distance = msg.distance
      state.ycorder.duration = msg.duration
    },
    // 设置线路详情
    setLineinfo(state, msg) {
      state.lineinfo = msg
    },
    // 设置约车的类型
    setYcType(state, type) {
      state.ycorder.yctype = type
    },
    // 设置是否反转
    setIsreverse(state, isreverse) {
      state.isreverse = isreverse
    },
    // 设置是否反转
    setRatio(state, ratio) {
      state.ratio = ratio
    },
    // 设置用户名

    // 设置用户mobile
    setMobile(state, mobile) {
      state.userinfo.mobile = mobile
      state.ycorder.mobile = mobile
      localStorage.setItem('userinfo', JSON.stringify(state.userinfo))
    },
    // 初始化ycorder
    initycorder(state, userinfo) {
      state.ycorder.userid = userinfo.id
      if (userinfo.orderusername) {
        state.ycorder.username = userinfo.orderusername// 默认为之前的下单姓名
      }
      if (userinfo.ordermobile) {
        state.ycorder.mobile = userinfo.ordermobile// 默认为之前的下单手机号
      }
    },
    // 下单成功过更新本地的默认手机号和下单姓名
    setDefaultOrderUser(state, orderinfo) {
      let tag = false
      if (orderinfo.username != state.userinfo.orderusername) {
        state.userinfo.orderusername = orderinfo.username
        tag = true
      }
      if (orderinfo.mobile != state.userinfo.ordermobile) {
        state.userinfo.ordermobile = orderinfo.mobile
        tag = true
      }
      if (tag) {
        localStorage.setItem('userinfo', JSON.stringify(state.userinfo))
      }
    },
    // 设置自动定位的区县
    setStartAuto(state, autoinfo) {
      state.ycorder.start_city = autoinfo.city
      state.ycorder.start_area = autoinfo.district
    },
    // 设置公司的电话号码
    setGsphone(state, autoinfo) {
      state.gsphone.complaint = autoinfo.complaint
      state.gsphone.contact = autoinfo.contact
    }
  },
  actions: {}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js